import { memo } from 'react';

import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';
import Dialog from '@zenbusiness/zui/Dialog';
import DialogActions from '@zenbusiness/zui/DialogActions';
import DialogContent from '@zenbusiness/zui/DialogContent';
import DialogHeader from '@zenbusiness/zui/DialogHeader';
import Divider from '@zenbusiness/zui/Divider';
import List from '@zenbusiness/zui/List';
import ListItem from '@zenbusiness/zui/ListItem';
import SharedAsset from '@zenbusiness/zui/SharedAsset';
import Text from '@zenbusiness/zui/Text';
import PropTypes from 'prop-types';

import useModalDisplayTracker from '#client/hooks/useModalDisplayTracker';

import { ContentWrapStyled } from './DownloadAppModal.styles';

const CustomText = ({ children }) => (
  <Text
    color="secondary"
    size="md"
  >
    {children}
  </Text>
);

const DownloadAppModal = ({ handleClose }) => {
  const trackMakeBankTransferClick = useButtonPressedCallback({
    elementName: 'forced_appdownload_check_deposit',
    elementText: 'Download app',
    appPageName: 'forced_app_download_modal'
  });
  const onDownloadApp = () => {
    trackMakeBankTransferClick();
    window.open('https://zenbusiness.onelink.me/NDnu/vmqjx9hl', '_blank');
  };

  useModalDisplayTracker({
    elementName: 'forced_app_download_modal',
    elementText: 'forced_app_download_modal',
    appPageName: 'forced_app_download_modal'
  });

  return (
    <Dialog
      onClose={handleClose}
      open
    >
      <Box sx={{ padding: '8px' }}>
        <DialogHeader
          sx={{
            textAlign: 'start'
          }}
          title="Please download the app to complete your deposit"
        />
        <DialogContent>
          <List
            sx={{
              listStyleType: 'disc',
              margin: '0',
              paddingLeft: '25px',
              '& .MuiListItem-root': {
                display: 'list-item',
                padding: '0'
              }
            }}
          >
            <ListItem>
              <CustomText>Deposit checks even faster</CustomText>
            </ListItem>
            <ListItem>
              <CustomText>Stay on top of transactions</CustomText>
            </ListItem>
            <ListItem>
              <CustomText>Make business banking simpler</CustomText>
            </ListItem>
          </List>
          <ContentWrapStyled>
            <SharedAsset
              alt=""
              src="/s2/vector/mobile-app.svg"
              width="50%"
            />
          </ContentWrapStyled>
        </DialogContent>
        <Divider sx={{ margin: '0 16px' }} />
        <DialogActions>
          <Box sx={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <Button
              fullWidth
              onClick={onDownloadApp}
              size="lg"
              variant="contained"
            >
              Download app
            </Button>
          </Box>
        </DialogActions>
      </Box>
    </Dialog>
  );
};

DownloadAppModal.propTypes = {
  handleClose: PropTypes.func
};

export default memo(DownloadAppModal);
